<template>
  <div class="card">

    <div class="card-header">
      <slot name="header"></slot>
      <div v-show="showExpanded && !bottomShowToggleButtonInView" ref="topShowMoreButton" class="btn btn-sm btn-show-more" type="button" @click="showExpanded = !showExpanded">
        <i :class="showExpanded? 'fa fa-caret-up' : 'fa fa-caret-down'" aria-hidden="true"></i>
        <span v-text="showExpanded? ' show less ' : ' show more '" aria-hidden="true"></span>
      </div>
    </div>

    <hr>

    <div ref="cardBody" class="card-body" :class="showExpanded? 'expanded' : 'not-expanded'">
      <section ref="cardBodyContent" class="card-body-content" :class="{'min-height-for-multi-column': !!minHeightForMultiColumn}">
        <slot name="body"></slot>
      </section>
    </div>

    <div class="card-footer">
      <slot name="footer"></slot>
      <div v-show="displayShowToggleButtons" ref="bottomShowMoreButton" class="btn btn-sm btn-show-more" type="button" @click="showExpanded = !showExpanded">
        <i :class="showExpanded? 'fa fa-caret-up' : 'fa fa-caret-down'" aria-hidden="true"></i>
        <span v-text="showExpanded? ' show less ' : ' show more '" aria-hidden="true"></span>
      </div>
    </div>

  </div>
</template>



<script>

export default {
  name: "ExpandableCard",
  props: ['minHeightForMultiColumn'],
  emits: ['show-more', 'show-less'],

  data() {
    return {
      showExpanded: false,
      expandedIndex: 8,
      resizeObserver: null,
      intersectionObserver: null,
      displayShowToggleButtons: false,
      bottomShowToggleButtonInView: false,
    }
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(this.onContentResized);
    this.resizeObserver.observe(this.$refs.cardBodyContent);

    this.intersectionObserver = new IntersectionObserver(this.onBottomShowMoreButtonIntersection);
    this.intersectionObserver.observe(this.$refs.bottomShowMoreButton);
  },

  beforeUnmount() {
    this.resizeObserver?.disconnect();
    this.intersectionObserver?.disconnect();
  },

  watch: {
    showExpanded(newValue) {
      this.$emit(newValue ? 'show-more' : 'show-less');
    }
  },

  methods: {
    onContentResized() {

      const containerHeight = this.$refs.cardBody?.clientHeight; // the wrapping card body div
      const contentHeight = this.$refs.cardBodyContent?.scrollHeight; // the internal card body CONTENT div

     //console.log(`onCardBodyContentResized() : containerHeight=${containerHeight}  contentHeight=${contentHeight}`)

      this.displayShowToggleButtons = this.showExpanded || ( contentHeight > containerHeight );
    },
    onBottomShowMoreButtonIntersection(_entries) {
      const entry = _entries[0];
      if ( entry ) {
        this.bottomShowToggleButtonInView = entry.isIntersecting;
      }
    }
  }
}

</script>


<style scoped>

  .card {

    .btn-show-more {
      position: absolute;
      right: 1em;

      font-size: small;
      color: var(--bs-secondary);
      opacity: 80%;
    }

    .card-header {
      min-height: 60px;
      padding-top: 16px;
      padding-bottom: 0;
      background-color: inherit;
      border: none;

      .btn-show-more {
        background-color: inherit;
        top: 0;
      }

    }

    hr {
      margin: 0 15px 0 15px;
    }

    .card-body {
      position: relative;

      /* set card body padding to zero; the padding will be added to the content */
      padding: 0;

      &.not-expanded {
        overflow-y: hidden;
        max-height: 150px;
      }

      .card-body-content {
        /* give the card body content the padding the card body generally would have */
        padding: 16px 16px 0 16px;

        &.min-height-for-multi-column {
          @media not (max-width: 768px) {
            /*background-color: lightpink!important;*/
            min-height: 150px;
          }
        }
      }
    }

    .card-footer {
      min-height: 40px;
      background-color: inherit;
      border-top: none;

      .btn-show-more {
        bottom: 5px;
      }

    }
  }



</style>